import React, { forwardRef } from 'react';

import MUIPopover, {
  PopoverProps as MUIPopoverProps,
} from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  paper: {
    'box-shadow': '0px 4px 20px rgba(69, 69, 69, 0.25)',
    padding: '24px',
    marginTop: '12px',
  },
};

const StyledPopover = withStyles(styles)(MUIPopover);

const Popover = forwardRef<HTMLButtonElement, MUIPopoverProps>((props, ref) => {
  return <StyledPopover {...props} ref={ref} />;
});

Popover.displayName = 'Popover';

export default Popover;
